module.exports = __webpack_public_path__ + "static/media/arrow-right-circle.c487a7e9.svg";